import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import { Grid2 as Grid, List, ListItem, ListItemText, Paper, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material';
import React, { useContext } from 'react';
import { ProductsStore } from '../../utils/stores/ProductsStore';
import { widgetStyles } from './widgets/widgetStyles';

export default function KeySellingPointsWidget() {
    const theme = useTheme();
    const mediumDown = useMediaQuery(theme.breakpoints.down('md'));
    const smallDown = useMediaQuery(theme.breakpoints.down('sm'));
    const productController = useContext(ProductsStore);

    return (
        <Paper variant="outlined" sx={[widgetStyles.paper, widgetStyles.paperRight]}>
            <Grid container direction="column">
                <Typography variant="h5" style={{ fontWeight: 500, paddingBottom: 5 }}>
                    Reasons to Love It
                </Typography>
                <List>
                    {productController.product?.usp?.map((item: any) => (
                        <ListItem
                            key={item}
                            style={{
                                color: theme.palette.text.soft,
                                paddingTop: 3,
                                paddingBottom: 3,
                                paddingLeft: mediumDown ? 0 : 16,
                            }}
                        >
                            <div style={{ paddingRight: 30, display: 'flex' }}>
                                <FavoriteBorderOutlinedIcon color="primary" fontSize="small" />
                            </div>
                            <ListItemText>{item}</ListItemText>
                        </ListItem>
                    ))}
                </List>
            </Grid>
        </Paper>
    );
}
